import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsModel } from '../model/icms-model';

export class ICmsConfig<T extends IConfigData = IConfigData> extends ICmsModel<T, number> {
    static override readonly type = 'cmsConfig';
    static readonly cms = true;
    override maxVerbosity = 1;

    @NgInject(ICmsContentService)
    private iCmsContentService!: ICmsContentService;

    get meta() {
        return this.iCmsContentService.getConfig(this.data!.url.split('@')[0]);
    }

    protected override getName(): string {
        const meta = this.meta;
        if (!meta) {
            return 'Unknown configuration';
        }
        const variant = this.getVariant();
        return variant ? `${meta.name} (${variant})` : meta.name;
    }

    getVariant(): string | undefined {
        return this.data!.url.split('@')[1];
    }

    getBareUrl(): string {
        return this.data!.url.split('@')[0];
    }
}
